// extracted by mini-css-extract-plugin
export var articles = "partner-module--articles---WFAq";
export var article = "partner-module--article--18xqI";